- affiliation:
    en: National Institute of Advanced Industrial Science and Technology (AIST)
    ja: 産業技術総合研究所
  link:
    en: https://www.aist.go.jp/index_en.html
    ja: https://www.aist.go.jp/
  role:
    en: Researcher
    ja: 研究員
  term:
    en: Apr. 2023 - present
    ja: 2023年4月 - 現在
  topics:
    en: |
      affiliation: Artificial Intelligence Research Center (AIRC) /
      concurrent: TICO-AIST Cooperative Research Laboratory for Advanced Logistics
    ja: |
      所属: 人工知能研究センター 社会知能研究チーム /
      兼務: 豊田自動織機-産総研 アドバンスト・ロジスティクス連携研究ラボ
  location: Tokyo, Japan
  #
- affiliation:
    en: University of Cambridge
    ja: 英ケンブリッジ大学
  link: https://www.cst.cam.ac.uk/
  others:
    en: "Host : Prof. Amanda Prorok"
    ja: "ホスト : Prorok Amanda 教授"
  role:
    en: Visiting Postdoc Scholar
    ja: 客員研究員
  term:
    en: "May. 2023 - Dec. 2025"
    ja: "2023年5月 - 2025年12月"
  topics:
    en: |
      supported by JSPS Overseas Fellowship
    ja: |
      JSPS 海外特別研究員
  location: Cambridge, UK
  #
- affiliation:
    en: Japan Society for the Promotion of Science (JSPS)
    ja: 日本学術振興会
  link:
    en: https://www.jsps.go.jp/english/e-pd/index.html
    ja: https://www.jsps.go.jp/j-pd/index.html
  role:
    en: Research Fellowship for Young Scientists (DC1)
    ja: 特別研究員 (DC1)
  term:
    en: Apr. 2020 - Mar. 2023
    ja: 2020年4月 - 2023年3月
  topics:
    en: |
      Topics : Enhanced Cooperation of Moving Agents via an Active Modular Environment
    ja: |
      研究テーマ : 移動エージェント群の協調行動を誘発する環境による計算支援
  location: Tokyo, Japan
- affiliation:
    en: LIP6, Sorbonne University
    ja: LIP6, 仏ソルボンヌ大学
  link: https://www.lip6.fr/
  others:
    en: "Adviser : Prof. Sebastien Tixeuil"
    ja: "メンター : Tixeuil Sebastien 教授"
  role:
    en: Visiting Scholar
    ja: 客員研究員
  term:
    en: Feb. 2022 - Sep. 2022
    ja: "2022年2月 - 2022年9月"
  topics:
    en: "Topics : risk-aware multi-agent planning"
    ja: "研究テーマ : リスク下でのマルチエージェントプランニング"
  location: Paris, France
- affiliation:
    en: OMRON SINIC X
    ja: オムロンサイニックエックス株式会社
  link: https://www.omron.com/sinicx/
  others:
    en: "Adviser : Dr. Ryo Yonetani"
    ja: "メンター : 米谷竜 博士"
  role:
    en: Research Internship
    ja: 研究インターンシップ
  term:
    en: Apr. 2021 - Oct. 2021
    ja: 2021年4月 - 2021年10月
  topics:
    en: "Topics : data-driven multi-agent planning"
    ja: "研究テーマ : データ駆動型のマルチエージェントプランニング"
  location: Tokyo, Japan
- affiliation:
    en: Miyake Lab, Tokyo Institute of Technology
    ja: 東京工業大学 三宅研究室
  icon: tokyo-tech
  link: http://www.myk.dis.titech.ac.jp/
  others:
    en: "Adviser : Dr. Hiroki Ora"
    ja: "メンター : 大良宏樹 博士"
  role:
    en: Research Student
    ja: 研究生
  term:
    en: Jun. 2016 - Mar. 2020
    ja: 2016年6月 - 2020年3月
  topics:
    en: "Topics : Cognitive Science, Multimodal Integration, Body Ownership, VR"
    ja: "研究テーマ : 認知科学, 自己身体認知, 多感覚統合, VR"
  location: Kanagawa, Japan
- affiliation:
    en: NEC Data Science Lab
    ja: NEC データサイエンス研究所
  icon: nec
  link:
    en: https://www.nec.com/en/global/rd/labs/datascience/index.html
    ja: https://jpn.nec.com/rd/labs/datascience/index.html
  others:
    en: "Adviser : Mr. Shinji Nakadai"
    ja: "メンター : 中台慎二さん"
  role:
    en: Research Internship
    ja: 研究インターンシップ
  term:
    en: Aug. 2018 - Sep. 2018
    ja: 2018年8月 - 2018年9月
  topics:
    en: "Topics : Multi-agent System, Combinatorial Auction, Machine Learning"
    ja: "研究テーマ : マルチエージェントシステム, 組合せ最適化, 機械学習"
  location: Kanagawa, Japan
